import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { FC } from 'react';

export interface CircularLoaderProps {
  size?: number;
  color?: string;
  className?: string;
}

export const CircularLoader: FC<CircularLoaderProps> = ({ size = 40, color = '#004615', className }) => {
  return (
    <Spin
      className={['inline-flex items-center justify-center', className].filter(Boolean).join(' ')}
      indicator={
        <LoadingOutlined style={{ fontSize: size, color: color === 'inherit' ? 'currentColor' : color }} spin />
      }
    />
  );
};
